import { useState } from "react";
import { stopEspeak } from "../../speak/speakPhonemes";
import { CheckBox } from "../widgets/CheckBox";
import { ColumnAlign } from "../widgets/ColumnAlign";
import { IpaButtons } from "../widgets/IpaButtons";
import { IpaKeyboard } from "../widgets/IpaKeyboard";
import { IpaType } from "../../phonemes/ipa";

/** UI for showing/modifying IPA & speaking it */
export function ShowIpa(props: {
  value: IpaType,
  onChange: (s: IpaType) => void,
  speakIpa: () => void,
  width: number,
}) {
  const [showKeyboard, setKeyboard] = useState(false);
  const [insert, setInsert] = useState<[string] | undefined>();
  const [ipaText, setIpaText] = useState('');
  const [delayedCheck, setDelayedCheck] = useState(false);

  // has parent changed the text?
  if (props.value !== ipaText) {
    // if different, wait a bit for events to finish percolating
    // before checking again to see if the parent asked for a change
    setTimeout(() => setDelayedCheck(true), 10/*ms*/);
  }
  if (delayedCheck) {  // delayed check
    setDelayedCheck(false);
    if (props.value !== ipaText) {
      // if it's still different, the parent must have changed it
      setIpaText(props.value);
    }
  }

  function changeShowKeyboard(checked: boolean) {
    setKeyboard(checked);
    document.getElementById('ortho-output')?.focus();
  }

  /** user changed the text */
  function changeInputText(newText: string) {
    setIpaText(newText);
    props.onChange(newText);
  }

  return (<>
    <ColumnAlign width={props.width}>{[
      <span key={1}>output IPA:</span>,
      <span key={2}>
        <CheckBox checked={showKeyboard} onChange={changeShowKeyboard}>show IPA keyboard</CheckBox>
      </span>,
      <span key={3}>
        <button onClick={() => props.speakIpa()}>speak output</button>
        &nbsp;&nbsp;&nbsp;
        <button onClick={() => stopEspeak()}>stop</button>
      </span>,
    ]}</ColumnAlign>
    {showKeyboard ? <IpaButtons onClick={(s) => setInsert([s])} ipa={true} width={props.width} /> : <></>}
    <IpaKeyboard id='ortho-output' cols={80} rows={5}
      value={ipaText} onChange={changeInputText} onSpeak={props.speakIpa} insert={insert} />
  </>);
}
